export default __webpack_public_path__ + "static/media/web-new.713d6d09.svg";